import { useState } from 'react';

import { appointmentStatuses } from 'constants';

import Button from 'components/shared/Buttons/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';

import MultiActions from './MultiActions';

const ButtonActions = ({ selectedRows = [], gridApi, handleInvoiceModalOpen = () => {} }) => {
  const [type, setType] = useState();
  const [appointmentStatus, setAppointmentStatus] = useState();
  const [multiActionsModal, setMultiActionsModal] = useState({
    appointmentCreation: false,
    appointmentReminder: false,
    appointmentCancel: false,
    appointmentStatus: false
  });

  const appointmentOptions = [
    {
      label: 'Resend Appointment Creation',
      icon: 'calendar-tick-mono',
      children: [
        {
          label: 'Email',
          icon: 'mail-mono',
          onClick: () => {
            setType('email');
            setMultiActionsModal((prevState) => ({ ...prevState, appointmentCreation: true }));
          }
        },
        {
          label: 'Text Message',
          icon: 'message-mono',
          onClick: () => {
            setType('email');
            setMultiActionsModal((prevState) => ({ ...prevState, appointmentCreation: true }));
          }
        }
      ]
    },
    {
      label: 'Resend Appointment Reminder/Forms',
      icon: 'calendar-reminder-mono',
      children: [
        {
          label: 'Email',
          icon: 'mail-mono',
          onClick: () => {
            setType('email');
            setMultiActionsModal((prevState) => ({ ...prevState, appointmentReminder: true }));
          }
        },
        {
          label: 'Text Message',
          icon: 'message-mono',
          onClick: () => {
            setType('text_message');
            setMultiActionsModal((prevState) => ({ ...prevState, appointmentReminder: true }));
          }
        }
      ]
    },
    {
      label: 'Cancel Appointment',
      icon: 'calendar-remove-mono',
      onClick: () =>
        setMultiActionsModal((prevState) => ({ ...prevState, appointmentCancel: true }))
    }
  ];

  const onAppointmentStatusClick = (status) => {
    setAppointmentStatus(status.value);
    setMultiActionsModal((prevState) => ({ ...prevState, appointmentStatus: true }));
  };

  const updatedAppointmentStatuses = appointmentStatuses.map((status) => ({
    ...status,
    onClick: () => onAppointmentStatusClick(status)
  }));

  return (
    <>
      <Popover
        className="flex flex-1 justify-center self-center"
        position="left"
        isFixed
        options={appointmentOptions}
      />
      <Popover
        text="Appointment Status"
        placeholder="Appointment Status"
        textClassName="text-neutral-700"
        buttonClassName="w-[200px] px-4"
        panelClassName="max-h-[400px] overflow-y-auto"
        isFixed
        isBorder
        isDropdown
        icon={false}
        options={updatedAppointmentStatuses}
        optionsGroupBy="property_of"
      />
      <MultiActions
        multiActionsModal={multiActionsModal}
        setMultiActionsModal={setMultiActionsModal}
        appointments={selectedRows}
        appointmentStatus={appointmentStatus}
        type={type}
        gridApi={gridApi}
        setAppointmentStatus={setAppointmentStatus}
      />
      <Button
        disabled={!selectedRows?.length}
        size="small"
        data-qa="invoice-patient-btn"
        onClick={() => handleInvoiceModalOpen()}
        text="Invoice Patient"
      />
    </>
  );
};
export default ButtonActions;
